import { authenticationService } from './authentication.service'
import { notify } from '../helpers/notify'

export default function handleResponse(response) {
  return response.json().then(data => {
    if (!response.ok) {
      if ([401, 403].indexOf(response.status) !== -1) {
        const hash = window.location.hash || ''
        const onPublicAuth = hash.startsWith('#!/login') || hash.startsWith('#!/forgot') || hash.startsWith('#!/reset') || hash.startsWith('#!/register')
        // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
        authenticationService.logout()
        if (!onPublicAuth) window.location.reload(true)
      } else if (response.status === 402) {
        // notify.toast('Du har inget aktivt abonnemang', 'warning')
        window.location.hash = '#!/setting/membership'
      } else if (response.status === 404) {
        window.location.hash = '#!/404'
      }
      return Promise.reject([response, data])
    } else {
      return data
    }
  })
}
